import * as React from "react";
import { _t } from "../../../utils/Translator";
import Partner from "../../../classes/Partner";
import "./RecipientChooser.css";

const defaultContactImageSrc = "assets/avatar_grey.png";

export type RecipientCandidate = {
  email: string;
  displayName: string;
  source: "to" | "cc" | "sender";
  isExternal?: boolean;
  image?: string;
  partnerId?: number;
  partner?: Partner;
};

type RecipientChooserProps = {
  candidates: RecipientCandidate[];
  selectedCandidate?: RecipientCandidate;
  onSelect: (candidate: RecipientCandidate) => void;
};

const RecipientChooser = (props: RecipientChooserProps) => {
  const getInitials = (displayName: string, email: string) => {
    const partnerLike = new Partner();
    partnerLike.name = (displayName || email || "?").trim();
    return partnerLike.getInitials() || partnerLike.name.substring(0, 1).toUpperCase() || "?";
  };

  const getAvatar = (candidate: RecipientCandidate) => {
    if (candidate.image) {
      return (
        <img
          className="recipient-chooser__avatar recipient-chooser__avatar-image"
          src={Partner.getImageDataUrl(candidate.image)}
          alt={candidate.displayName || candidate.email}
          onError={ev => {
            ev.currentTarget.onerror = null;
            ev.currentTarget.src = defaultContactImageSrc;
          }}
        />
      );
    }

    return (
      <div className="recipient-chooser__avatar" aria-hidden="true">
        <span className="recipient-chooser__avatar-initials">
          {getInitials(candidate.displayName, candidate.email)}
        </span>
      </div>
    );
  };

  return (
    <section className="recipient-chooser">
      <div className="section-card recipient-chooser__card">
        <div className="recipient-chooser__header">
          <div>
            <h2>{_t("Choose who to use for Odoo context")}</h2>
            <p>
              {_t(
                "We found multiple relevant people in this email. Pick the person whose Odoo records you want to open."
              )}
            </p>
          </div>
        </div>

        <div className="recipient-chooser__list">
          {props.candidates.map(candidate => {
            const isSelected = props.selectedCandidate?.email === candidate.email;
            return (
              <button
                type="button"
                key={candidate.email}
                className={`recipient-chooser__item ${isSelected ? "is-selected" : ""}`}
                onClick={() => props.onSelect(candidate)}
              >
                {getAvatar(candidate)}
                <div className="recipient-chooser__content">
                  <div className="recipient-chooser__row">
                    <span className="recipient-chooser__name">{candidate.displayName || candidate.email}</span>
                  </div>
                  <div className="recipient-chooser__email">{candidate.email}</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RecipientChooser;
